import React from 'react'

import ConfigLoader from './_load/ConfigLoader'
import ControlledModal from '../../../../components/modals/ControlledModal'
import EditConfigForm from './EditConfigForm'
import Line from '../../../../packages/kiti/components/helpers/Line'
import ModalHeader from './ModalHeader'
import Separator from '../../../../components/helpers/Separator'

const ConfigModal = props => {
  return (
    <ControlledModal width="28rem" {...props}>
      <ConfigLoader>
        <ModalHeader />
        <Line />
        <Separator weight={4} />
        <EditConfigForm />
      </ConfigLoader>
    </ControlledModal>
  )
}

export default ConfigModal
